// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../../Assets/images/Jetons-card-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.packvideo-page {
  max-width: 1200px; /* Ajustez selon votre mise en page */
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

.packvideo-header {
  text-align: center;
  margin-bottom: 30px;
}

.packvideo-slider {
  display: flex;
  justify-content: center;
}

.parent-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.packVideo-card {
  flex: 1 1;
  margin: 10px; /* Adjust margin as needed */
}

.packvideo-card h3 {
  color: #333;
}

.packvideo-card p {
  color: #777;
}

.packvideo-card ul {
  list-style-type: none;
  padding: 0;
}

.packvideo-card li {
  margin-bottom: 5px;
}

.packvideo-card button {
  background-color: #4caf50;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.packvideo-card button:hover {
  background-color: #45a049;
}

.view-more-button {
  margin-top: 20px;
  text-align: center;
}

.view-more-button {
  background-color: #4AAE9B;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.view-more-button button:hover {
  background-color: #4AAE9B;
}

.acheter {
  border: 2px solid #D6A77A !important;
  background-color: #D6A77A !important;
  color: rgb(255, 255, 255) !important;
  padding: 10px 28px !important;
  font-size: 18px !important;
  cursor: pointer !important;
  border-radius: 40px !important;
  transition: background-color 0.3s ease-in-out;
  font-family: 'Lato';
}

.acheter:hover {
  border: 2px solid #C9BAAC !important;
  background-color: #C9BAAC !important;
  color: #ffffff !important;
  padding: 10px 28px !important;
  font-size: 18px !important;
  cursor: pointer !important;
  border-radius: 40px !important;
  transition: background-color 0.3s ease-in-out;
  font-family: 'Lato';
}
.packvideo-details{
  background-repeat: no-repeat;
  background-position: center;
  padding: 43px
}

@media (max-width: 768px) {
.packvideo-details{
  background-repeat: no-repeat;
  background-position: center;
  padding: 43px 35px;
  background-size: contain;
}
}
.plan-price {
  font-size: 40px;  /* Adjust the size of the h1 element */
  font-weight: bold;
}
@media (max-width: 768px) {
  .plan-price {
      font-size: 30px; /* Smaller font size for screens under 768px */
  }
}

.card-jeton{
  background-color: transparent !important;
  background: none;
  border: none;
  box-shadow: none !important;
}

.card-body-jeton{
  padding: 2rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
background-position: center;
background-size: cover;
background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/PackvideoPage/Packvideo/Components/PackvideoCard/PackvideoCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE,qCAAqC;EACxD,cAAc;EACd,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B;AACF;;AAEA;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;AACA;EACE,eAAe,GAAG,sCAAsC;EACxD,iBAAiB;AACnB;AACA;EACE;MACI,eAAe,EAAE,8CAA8C;EACnE;AACF;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yDAA4E;AAC9E,2BAA2B;AAC3B,sBAAsB;AACtB,4BAA4B;AAC5B","sourcesContent":[".packvideo-page {\n  max-width: 1200px; /* Ajustez selon votre mise en page */\n  margin: 0 auto;\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.packvideo-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.packvideo-slider {\n  display: flex;\n  justify-content: center;\n}\n\n.parent-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.packVideo-card {\n  flex: 1;\n  margin: 10px; /* Adjust margin as needed */\n}\n\n.packvideo-card h3 {\n  color: #333;\n}\n\n.packvideo-card p {\n  color: #777;\n}\n\n.packvideo-card ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.packvideo-card li {\n  margin-bottom: 5px;\n}\n\n.packvideo-card button {\n  background-color: #4caf50;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.packvideo-card button:hover {\n  background-color: #45a049;\n}\n\n.view-more-button {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.view-more-button {\n  background-color: #4AAE9B;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.view-more-button button:hover {\n  background-color: #4AAE9B;\n}\n\n.acheter {\n  border: 2px solid #D6A77A !important;\n  background-color: #D6A77A !important;\n  color: rgb(255, 255, 255) !important;\n  padding: 10px 28px !important;\n  font-size: 18px !important;\n  cursor: pointer !important;\n  border-radius: 40px !important;\n  transition: background-color 0.3s ease-in-out;\n  font-family: 'Lato';\n}\n\n.acheter:hover {\n  border: 2px solid #C9BAAC !important;\n  background-color: #C9BAAC !important;\n  color: #ffffff !important;\n  padding: 10px 28px !important;\n  font-size: 18px !important;\n  cursor: pointer !important;\n  border-radius: 40px !important;\n  transition: background-color 0.3s ease-in-out;\n  font-family: 'Lato';\n}\n.packvideo-details{\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 43px\n}\n\n@media (max-width: 768px) {\n.packvideo-details{\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 43px 35px;\n  background-size: contain;\n}\n}\n.plan-price {\n  font-size: 40px;  /* Adjust the size of the h1 element */\n  font-weight: bold;\n}\n@media (max-width: 768px) {\n  .plan-price {\n      font-size: 30px; /* Smaller font size for screens under 768px */\n  }\n}\n\n.card-jeton{\n  background-color: transparent !important;\n  background: none;\n  border: none;\n  box-shadow: none !important;\n}\n\n.card-body-jeton{\n  padding: 2rem !important;\n  background-image: url(../../../../../../../Assets/images/Jetons-card-bg.png);\nbackground-position: center;\nbackground-size: cover;\nbackground-repeat: no-repeat;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
